var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('div', {
    staticClass: "v-list v-sheet",
    class: {
      'v-list--dense': _vm.dense
    },
    attrs: {
      "role": "list"
    }
  }, [_vm._t("default")], 2);
};
var staticRenderFns = [];
export { render, staticRenderFns };